import { combineReducers } from '../../dependencies';

import byId from './byId';
import ids from './ids';

export default combineReducers({
    byId,
    ids,
});
